import vr from "../../../../../utils/Verifiers";
class FormulasBloques {
    constructor() { }

    sumar_semanas = (semanaAnio, agregar, setdialog) => {
        semanaAnio = vr.numberFormat(semanaAnio, 0);
        agregar = vr.numberFormat(agregar, 0);

        if ((semanaAnio - 2000) < 24) {
            this.avisar("No se pueden definir entradas para años anteriores a 2024", setdialog);
            return false;
        }
        const valorString = semanaAnio.toString();
        const anio = parseInt(valorString.substring(0, 2));
        const semana = parseInt(valorString.substring(2, 4));
        let semanasAnioTotal = this.semanas_en_anio(anio + 2000);

        if (semana < 1 || semana > semanasAnioTotal) {
            this.avisar(`El valor de la semana debe estar entre 1 y ${semanasAnioTotal}`, setdialog);
            return false;
        }

        let nuevaSemana = semana + agregar;

        let nuevoAnio = anio;
        if (nuevaSemana > semanasAnioTotal) {
            while (nuevaSemana > semanasAnioTotal) {
                nuevaSemana -= semanasAnioTotal;
                nuevoAnio += 1;
                semanasAnioTotal = this.semanas_en_anio(nuevoAnio + 2000);
            }
        } else if (nuevaSemana < 1) {
            while (nuevaSemana < 1) {
                nuevoAnio -= 1;
                semanasAnioTotal = this.semanas_en_anio(nuevoAnio + 2000);
                nuevaSemana += semanasAnioTotal;
            }
        }
        const nuevaSemanaString = `${String(nuevoAnio).padStart(2, "0")}${String(nuevaSemana).padStart(2, "0")}`;
        return nuevaSemanaString;
    }

    avisar(mensaje, setdialog) {
        if (!setdialog) return;
        return vr.activeDialog(setdialog, mensaje, "Error", 'error');
    }

    semana_a_fecha(numeroSemana) {
        const regex = /^[0-9]{4}$/;

        if (numeroSemana === null || numeroSemana === "" || !regex.test(String(numeroSemana))) {
            return null;
        }

        let semana = Number(String(numeroSemana).substring(2, 4));
        let anio = Number(String(numeroSemana).substring(0, 2));

        if (semana < 1 || semana > 53 || anio < 1) {
            return null;
        }

        anio += 2000;

        const addDaysUTC = (date, days) => {
            const copy = new Date(date.getTime());
            copy.setUTCDate(copy.getUTCDate() + days);
            return copy;
        };

        const addWeeksUTC = (date, weeks) => addDaysUTC(date, weeks * 7);

        const toISODate = (date) => {
            const y = date.getUTCFullYear();
            const m = String(date.getUTCMonth() + 1).padStart(2, "0");
            const d = String(date.getUTCDate()).padStart(2, "0");
            return `${y}-${m}-${d}`;
        };

        // MySQL WEEKDAY: 0=Monday ... 6=Sunday
        const mysqlWeekday = (date) => {
            const jsDay = date.getUTCDay(); // 0=Sunday ... 6=Saturday
            return jsDay === 0 ? 6 : jsDay - 1;
        };

        const primerDia = new Date(Date.UTC(anio, 0, 1));

        if (semana === 1) {
            return toISODate(primerDia);
        }

        let primerLunes;

        const diaNumero = mysqlWeekday(primerDia);

        if (diaNumero === 0) {
            primerLunes = new Date(primerDia);
        } else {
            const diaNumeroAjustado = 6 - (diaNumero - 1);
            primerLunes = addDaysUTC(primerDia, diaNumeroAjustado);
        }

        const semanasDesdePrimerLunes =
            primerLunes.getTime() === primerDia.getTime()
                ? semana
                : semana - 1;

        let ultimoDia = addWeeksUTC(primerLunes, semanasDesdePrimerLunes);
        ultimoDia = addDaysUTC(ultimoDia, -1);

        if (ultimoDia.getUTCFullYear() !== anio) {
            const primerDiaResultado = addDaysUTC(ultimoDia, -6);

            if (primerDiaResultado.getUTCFullYear() !== anio) {
                return null;
            }

            return toISODate(primerDiaResultado);
        }

        const primerDiaResultado = addDaysUTC(ultimoDia, -6);
        return toISODate(primerDiaResultado);
    }

    semanas_en_anio(panio) {
        if (!Number.isInteger(panio) || panio < 0) return null;

        const fechaFinAnio = new Date(Date.UTC(panio, 11, 31)); // 31/12/panio
        const semanaResultado = this.fechaASemana(fechaFinAnio);

        if (semanaResultado === null || semanaResultado === undefined || semanaResultado === "") {
            return null;
        }

        const semana = Number(String(semanaResultado).slice(2, 4));
        return Number.isFinite(semana) ? Math.round(semana) : null;
    }


    // helper de fecha
    addDaysUTC(date, days) {
        const copy = new Date(date.getTime());
        copy.setUTCDate(copy.getUTCDate() + days);
        return copy;
    }

    // MySQL WEEKDAY: 0 = Monday, ..., 6 = Sunday
    mysqlWeekday(date) {
        const jsDay = date.getUTCDay(); // 0 = Sunday, ..., 6 = Saturday
        return jsDay === 0 ? 6 : jsDay - 1;
    }

    fechaASemana(pfecha) {
        if (!(pfecha instanceof Date) || Number.isNaN(pfecha.getTime())) {
            return null;
        }

        const anio = pfecha.getUTCFullYear();
        const primerDiaAnio = new Date(Date.UTC(anio, 0, 1));

        let primerLunesAnio;
        const diaNumeroAnio = this.mysqlWeekday(primerDiaAnio);

        if (diaNumeroAnio === 0) {
            primerLunesAnio = new Date(primerDiaAnio);
        } else {
            primerLunesAnio = this.addDaysUTC(primerDiaAnio, 7 - diaNumeroAnio);
        }

        let primerDiaSemana;
        const diaNumeroFecha = this.mysqlWeekday(pfecha);

        if (diaNumeroFecha !== 0) {
            primerDiaSemana = this.addDaysUTC(pfecha, -diaNumeroFecha);

            if (primerDiaSemana.getUTCFullYear() !== anio) {
                primerDiaSemana = new Date(primerDiaAnio);
            }
        } else {
            primerDiaSemana = new Date(pfecha);
        }

        if (primerDiaSemana.getTime() < primerLunesAnio.getTime()) {
            return `${String(anio - 2000).padStart(2, "0")}01`;
        }

        let semanaInt;

        if (primerDiaSemana.getTime() === primerLunesAnio.getTime()) {
            semanaInt = 1;
        } else {
            const diffDias = Math.floor(
                (primerDiaSemana.getTime() - primerLunesAnio.getTime()) / 86400000
            );
            semanaInt = Math.ceil(diffDias / 7) + 1;
        }

        if (primerLunesAnio.getTime() !== primerDiaAnio.getTime()) {
            semanaInt += 1;
        }

        const anioBase = String(anio - 2000).padStart(2, "0");
        return `${anioBase}${String(semanaInt).padStart(2, "0")}`;
    }

    semanaValida = (semana) => {
        const semanaString = semana.toString();
        if (semanaString.length !== 4) return false;
        const anio = parseInt(semanaString.slice(0, 2), 10);
        if (anio < 10) {
            return false;
        }
        const semanaNum = parseInt(semanaString.slice(2, 4), 10);
        const semanasAnioTotal = this.semanas_en_anio(anio + 2000);
        if (semanaNum < 1 || semanaNum > semanasAnioTotal) {
            return false;
        }
        return true;
    }


    toNumber = (value, fallback = 0) => {
        const parsed = Number(value);
        return Number.isFinite(parsed) ? parsed : fallback;
    }

    cantidadTallos = (selecciones) => {
        const next = { ...selecciones };
        const plantas = this.toNumber(next.plantas, 0);
        const recuperacion = this.toNumber(next.recuperacion, 0);
        const cantidadTallos = this.toNumber(next.cantidadTallos, 0);

        next.plantas = plantas;
        next.recuperacion = cantidadTallos !== 0 ? Math.round(cantidadTallos / plantas * 100) / 100 : recuperacion;
        next.cantidadTallos = cantidadTallos;

        return next;
    }

    recuperacion = (selecciones) => {
        const next = { ...selecciones };
        const plantas = this.toNumber(next.plantas, 0);
        const recuperacion = this.toNumber(next.recuperacion, 0);
        const cantidadTallos = recuperacion * plantas;

        next.plantas = plantas;
        next.recuperacion = recuperacion;
        next.cantidadTallos = cantidadTallos;
        return next;
    }

    reqm2 = (selecciones) => {
        const next = { ...selecciones };
        const plantas = this.toNumber(next.plantas, 0);
        const reqm2 = this.toNumber(next.reqm2, 0);
        const densidad = Math.round(this.toNumber(next.densidad, 0));

        next.plantas = plantas;
        next.reqm2 = reqm2;
        next.densidad = reqm2 !== 0 ? Math.round(plantas / reqm2 * 100) / 100 : densidad;

        return next;
    }

    densidad = (selecciones) => {
        const next = { ...selecciones };
        const plantas = this.toNumber(next.plantas, 0);
        const densidad = this.toNumber(next.densidad, 0);
        const reqm2 = this.toNumber(next.reqm2, 0);

        next.plantas = plantas;
        next.densidad = densidad;
        next.reqm2 = densidad !== 0 ? Math.round(plantas / densidad * 100) / 100 : reqm2;

        return next;
    }

    charolas = (selecciones) => {
        const next = { ...selecciones };
        const charolas = this.toNumber(next['charolas'], 0);
        const semillas = this.toNumber(next['semillas'], 0);
        const cavidad = Math.ceil(this.toNumber(next.cavidad, 0));

        next.semillas = semillas;
        next['charolas'] = charolas;
        next.cavidad = charolas !== 0 ? Math.round(semillas / charolas) : cavidad;

        return next;
    }

    cavidad = (selecciones) => {
        const next = { ...selecciones };
        const cavidad = this.toNumber(next.cavidad, 0);
        const semillas = this.toNumber(next['semillas'], 0);
        const charolas = this.toNumber(next['charolas'], 0);

        next.semillas = semillas;
        next.cavidad = cavidad;
        next['charolas'] = cavidad !== 0 ? Math.ceil(semillas / cavidad * 100) / 100 : charolas;

        return next;
    }

    semillas = (selecciones) => {
        const next = { ...selecciones };
        const plantas = this.toNumber(next.plantas, 0);
        const semillas = this.toNumber(next['semillas'], 0);
        const por_germinacion = this.toNumber(next.por_germinacion, 0);

        next.plantas = plantas;
        next['semillas'] = semillas;
        next.por_germinacion = semillas !== 0 ? Math.ceil(plantas / semillas * 100) / 100 : por_germinacion;
        const nex2 = this.cavidad(next);
        return nex2;
    }

    por_germinacion = (selecciones) => {
        const next = { ...selecciones };
        const por_germinacion = this.toNumber(next.por_germinacion, 0);
        const plantas = this.toNumber(next.plantas, 0);
        const semillas = this.toNumber(next['semillas'], 0);

        next.plantas = plantas;
        next.por_germinacion = por_germinacion;
        next['semillas'] = por_germinacion !== 0 ? Math.ceil(plantas / por_germinacion) : semillas;

        const next2 = this.cavidad(next);
        return next2;
    }

    plantas = (selecciones) => {
        const next = { ...selecciones };
        next.plantas = this.toNumber(next.plantas, 0);

        const conpor_germinacion = this.por_germinacion(next);
        const conCharolas = this.cavidad(conpor_germinacion);
        const con_metros = this.reqm2(conCharolas);
        const conTallos = this.recuperacion(con_metros);
        return this.densidad(conTallos);
    }

}

export default FormulasBloques;